export default "__VITE_ASSET__c8ZJp9BM__"